import jobQuotesReducer, {
    ToolkitJobQuotesActions,
} from "@toolkit/Framework/Store/Toolkit/Data/JobQuotes/JobQuotesReducer";
import { combineReducers } from "redux";

const dataReducers = {
    jobQuotes: jobQuotesReducer,
};

export type ToolkitDataActions = ToolkitJobQuotesActions;
export default combineReducers(dataReducers);
